export default {
  orsLPolyline: {
    type: 'Typ',
    surface: 'Oberfläche',
    unknownSurfaceType: 'Unbekannt'
  }
}
